module.exports = __webpack_public_path__ + "img/10.a904b73f.jpg";